import { OidcConfigService } from "angular-auth-oidc-client";
import { environment } from "../../environments/environment";

export function configureAuth(oidcConfigService: OidcConfigService) {

    return () =>
      oidcConfigService.withConfig({
        stsServer: environment.authUrl,
        redirectUrl: `${window.location.origin}${environment.redirectUri}`,
        postLogoutRedirectUri: environment.logoutUri,
        clientId: 'site',
        scope: 'openid profile email siteApi IdentityServerApi adminApi.pdf',
        responseType: 'code',
        logLevel: environment.logLevel,
        silentRenew: true,
        //useRefreshToken: true,
        silentRenewUrl: `${window.location.origin}${environment.baseHref}silent.html`,
        autoUserinfo: true,
        renewUserInfoAfterTokenRenew: true
      });
  }
